import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// Mui core
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

// Custom components
import TabPanel from "../../../../general/TabPanel";
import Data from "./physicalTabs/Data";
import Falls from "./physicalTabs/Falls";

// Icons
import { MdOutlineLocalHospital, MdAttachFile } from "react-icons/md";

const PhysicalExercice: React.FC<any> = ({ participant = null, index, tabName }) => {
    const hist = useHistory();

    // States
    const [tab, setTab] = useState(0);
    const [falls, setFalls] = useState<any[]>([]);

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const mobileScreenSize = 500;

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const tabs: any = [
        {
            label: "Data",
            icon: <MdAttachFile />,
            component: Data,
        },
        {
            label: "Falls",
            icon: <MdOutlineLocalHospital />,
            component: Falls,
        },
    ];

    // Fetching & sorting events
    useEffect(() => {
        if (participant && participant.physical && participant.physical.falls) {
            const localFalls = participant.physical.falls;
            localFalls.sort((a: any, b: any) => (a.date as any).seconds - (b.date as any).seconds);
            setFalls(localFalls);
        }
    }, [participant]);

    useEffect(() => {
        setTab(parseInt(index));
    }, [index]);

    return (
        <div>
            <div>
                <div className="tab__background__color">
                    <Tabs
                        variant="fullWidth"
                        value={tab}
                        onChange={(e, v) => participant && participant.id && hist.push(`/dashboard/participant/${participant.id}/${tabName}/${v}`)}
                    >
                        {tabs.map((t: any) => (
                            <Tab key={t.label} icon={t.icon} label={screenWidth >= mobileScreenSize ? t.label : ""} />
                        ))}
                    </Tabs>
                </div>
                {tabs.map((t: any, i: number) => (
                    <TabPanel key={i} value={tab} index={i}>
                        <t.component participant={participant} falls={falls} />
                    </TabPanel>
                ))}
            </div>
        </div>
    );
};

export default PhysicalExercice;
